// extracted by mini-css-extract-plugin
export default {"component":"page_component__eqSsh"};